import React from 'react';

import { useUserDetails } from '@investown/fe/api-sdk';

import CompanyName from 'components/CompanyName';
import UserFullName from 'components/UserFullName';

interface Props {
  firstNameOnly?: boolean;
}

const UserDisplayName: React.FC<Props> = ({ firstNameOnly }) => {
  const { data, isLoading } = useUserDetails();

  return data?.companyId && !isLoading ? (
    <CompanyName companyId={data.companyId} />
  ) : (
    <UserFullName firstNameOnly={firstNameOnly} />
  );
};

export default UserDisplayName;
